<template>
  <div class="custom-table">
    <div v-if="employees" class="table-responsive" style="min-height: 60vh;">
      <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800">
        <thead>
        <tr class="align-middle bg-gray-100i">
          <td v-if="roleAdmin.includes(this.$user.role) || roleModerator.includes(this.$user.role)" colspan="7" class="text-center">
            <div
                @click="openModel(null, null, null, false)"
                class="rounded border border-dashed pt-6 pb-6 cursor-pointer text-gray-400 border-gray-300 text-hover-primary border-hover-primary"
                style="border-width: 1px;">Добавить</div>
          </td>
          <td :colspan="roleAdmin.includes(this.$user.role) ? 2 : 9" style="width: 100px" class="text-center">
            <div
                @click="filterToggle"
                class="rounded border border-dashed pt-6 pb-5 cursor-pointer text-primary border-success"
                style="border-width: 1px;">
              <i class="ki-outline text-primary fs-3" :class="isFilter ? 'ki-cross' : 'ki-magnifier'"></i>
            </div>
          </td>
        </tr>
        <tr v-if="isFilter">
          <td colspan="8">
            <branch-employees-search :d-users="getDUsers" :d-dep="getDDepartments" :filter="filter" @search="getUsers"/>
          </td>
        </tr>
        <tr class="fw-bold fs-8 text-gray-400">
          <th style="width: 70px;">ID</th>
          <th>ИИН</th>
          <th>Ф.И.О</th>
          <th>БМГ</th>
          <th>Роль</th>
          <th>Тип</th>
          <th>Привязано к</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in employees.data">
          <td v-html="item.id" class="w-80px"></td>
          <td v-html="item.iin" style="width: 102px"></td>
          <td>
            <div class="cursor-help" :title="item.title" style="-webkit-box-orient: vertical;-webkit-line-clamp: 1;display: -webkit-box;overflow: hidden;">
              {{item.title}}
            </div>
          </td>
          <td class="w-20px">
            <i class="mt-1 d-block ki-outline fs-5"
               :class="item.bmg === 1 ? 'ki-check-square text-success' : 'ki-cross-square text-danger'"
            ></i>
          </td>
          <td v-html="this.getRoleName(item.role)" class="w-100px"></td>
          <td v-html="this.getTypeName(item.type)" class="w-90px"></td>
          <td v-html="item.branch"></td>
          <td class="text-end w-20px">
            <span class="btn-activated cursor-pointer" @click="openModel(item.id, item.role, item.title, true)">
              <i class="ki-outline ki-notepad-edit text-primary fs-4"></i>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <bootstrap5-pagination class="pagination-outline p-3 border-top" v-if="employees" :limit="3" :data="employees" @pagination-change-page="getUsers"/>
  </div>
</template>

<script>
import BranchEmployeesSearch  from '@/components/Branch/Search/BranchEmployeesSearch'
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import permissions            from '@/helpers/permissions'

export default {
  name: 'BranchEmployeesTable',
  components: { BranchEmployeesSearch, Bootstrap5Pagination },
  props: {
    employees: null,
    filter:    null
  },
  data() {
    return {
      loaded: false,
      isFilter: false
    }
  },
  mounted() {
    this.getDUsersRequest()
    this.getDDepartmentsRequest()
    this.getDTerminalsRequest()
  },
  computed: {
    getDUsers()       { return this.$store.getters.getUsersDic },
    getDTerminals()   { return this.$store.getters.getTerminalsDic },
    getDDepartments() { return this.$store.getters.getDepartmentsDic },
    roleModerator()   { return permissions.moderator() },
    roleAdmin()       { return permissions.admin() }

  },
  methods: {
    getDUsersRequest() {
      this.$store.dispatch('usersDicRequest')
    },
    getDTerminalsRequest() {
      this.$store.dispatch('terminalsDicRequest')
    },
    getDDepartmentsRequest() {
      this.$store.dispatch('departmentsDicRequest')
    },
    openModel(id, role, title, isEdit) {
      this.$store.dispatch('branchUserCreateUpdateModel', {id:id, title:title, isEdit: isEdit, role: 0})
      new bootstrap.Modal('#branchUserCreateUpdateModel', {}).show()
    },
    getUsers(val) {
      this.$emit('reloaded', val)
    },
    getRoleName(role) {
      return permissions.roleName(role)
    },
    getTypeName(type) {
      if (type === 0) return 'Нет 1C'
      if (type === 1) return 'C 1C'
      if (type === 2) return 'Локальный'
    },
    filterToggle() {
      this.isFilter = !this.isFilter
      if (!this.isFilter) {
        this.isDep        = false
        this.filter.user  = null
        this.filter.type  = null
        this.filter.role  = null
        this.filter.title = ''
        this.filter.iin   = ''
      }
    }
  },
  watch: {
    filter: {
      immediate: true,
      handler(val) {
        this.isFilter = val.user !== null || val.type !== null || val.role !== null || val.title || val.iin
      }
    }
  }
}
</script>

<style scoped>
.page-item {
  margin-right: .5rem;
  margin-bottom: .5rem;
}
</style>